<script>
import { Card } from "vant";
import { Image as VanImage } from "vant";
import { Switch } from "vant";
import { Col, Row } from "vant";

export default {
  props: {
    data: {
      type: Object,
      required: false,
    },
    exprired: {
      type: String,
      required: false,
    },
    showRenew: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    [Card.name]: Card,
    [Image.name]: Image,
    [VanImage.name]: VanImage,
    [Switch.name]: Switch,
    [Col.name]: Col,
    [Row.name]: Row,
  },
  data() {
    return {
      checked: true,
    };
  },
  methods: {
    fixedPrice(price) {
      if (price) {
        return price.toFixed(2);
      }
      return price;
    },
  },
};
</script>
<template>
  <van-card :thumb="data.iconUrl" class="van-card-post-confirm" v-if="data">
    <template #tags>
      <van-row>
        <van-col span="24">
          <div>
            <div
              class="d-flex van-row--justify-space-between van-row--align-center"
            >
              <h3 class="van-card__title">{{ data.serviceName }}</h3>
              <van-switch
                v-if="showRenew"
                class="van-switch-post"
                v-model="checked"
              />
            </div>
            <p class="van-card__desc">{{ data.shortDes }}</p>
          </div>
          <div class="d-flex align-items-center cs-van-tag">
            <van-tag plain type="danger" class="van-tag-icon">
              <div class="currency-unit-box">
                <p class="currency-unit">{{ data.unit }}</p>
              </div>
            </van-tag>
            <van-tag plain type="danger" class="van-tag-price">
              {{ fixedPrice(data.price) }}</van-tag
            >
            <van-tag plain type="danger" class="van-tag-day"
              >/ {{ data.serviceOrder }} {{ data.validity }}</van-tag
            >
          </div>
        </van-col>
      </van-row>
    </template>
  </van-card>
</template>

<style>
.currency-unit-box {
  margin: 0;
  width: 14px;
  height: 14px;
  background: #fdb913;
  border-radius: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
}
.currency-unit {
  margin: 0;
  color: #fff;
  font-size: 11px;
}
.van-card-post-confirm {
  background: #fff;
  padding-left: 0px;
  padding-right: 0px;
}

.van-card-post-confirm .van-card__header {
  align-items: start;
}

.van-card-post-confirm .van-card__title {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.09px;
  margin: 0px;
  margin-bottom: 4px;
}

.van-card-post-confirm .van-card__desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.32px;
  margin: 0;
  margin-bottom: 4px;
  color: #272d37;
  opacity: 0.699999988079071;
}

.van-card-post-confirm .cs-van-tag {
  margin-bottom: 4px;
  font-size: 12px;
}

.van-card-post-confirm .van-card__expired {
  margin: 0;
  margin-bottom: 4px;
  color: #fdb913;
  font-size: 12px;
  font-weight: 400;
}

.van-card-post-confirm .van-card__thumb {
  width: 56px;
  height: 56px;
}

.van-card-post-confirm .van-card__content {
  justify-content: center;
  min-height: fit-content;
}

.img-price {
  width: 14px;
  height: 14px;
  fill: #fdb913;
}

.van-tag-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.van-tag-price {
  font-size: 14px;
  font-weight: bold;
  color: #fdb913;
}

.van-tag-day {
  color: #272d37;
  font-size: 14px;
  font-weight: 500;
}

.van-switch-post.van-switch {
  height: 18px;
  width: 59.5px;
  background: #bebebe;
  position: relative;
}

.van-switch-post.van-switch.van-switch--on {
  background: #0d993d;
}

.van-switch-post.van-switch .van-switch__node {
  width: 15px;
  height: 15px;
  top: 1.5px;
  left: 2px;
}

.van-switch-post.van-switch--on.van-switch::before {
  left: 5px;
}

.van-switch-post.van-switch::before {
  content: "renew";
  display: block;
  font-size: 12px;
  position: absolute;
  top: 1.5px;
  right: 5px;
  color: #fff;
}

.van-switch-post.van-switch--on.van-switch .van-switch__node {
  left: 12px;
}

.van-switch {
  position: relative;
}

.van-switch .right:before {
  content: "renew";
  display: block;
  font-size: 12px;
  position: absolute;
  top: 2px;
  left: 3px;
}

.van-switch .left :before {
  content: "renew";
  display: block;
  font-size: 12px;
  position: absolute;
  top: 2px;
  right: -38px;
}
</style>
